import React, { useEffect, useState } from "react";
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
//import Treeviewpage from "./Treeviewpage";
//import TreeviewOrg from './TreeviewOrg';
import { useDispatch, useSelector } from "react-redux";
//import Tree_Alarm from "../../Tempdata/Tree_Alarm";
import {updatealarmaudiostate} from '../../../store/alarm_data';
import { RichTreeView } from '@mui/x-tree-view/RichTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import { Link } from 'react-router-dom';
import { Tooltip } from "@mui/material";
import { Checkbox } from '@mui/material';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import Button from '@mui/material/Button';
import LK_Filter from '../../../images/LK_Filter';
import LK_Settings from '../../../images/LK_Settings';

export default function AlertGeneralConfiguration(){
    const alarmcurrentaudiostate = useSelector((state) => state.alarmdata.alarmaudiostate)

    const[checkedstate, setCheckedState] = useState({
        checkedhighest: alarmcurrentaudiostate.enableAudioForHighest,
        checkedhigh: alarmcurrentaudiostate.enableAudioForHigh,
        checkedmedium: alarmcurrentaudiostate.enableAudioForMedium,
        checkedlow: alarmcurrentaudiostate.enableAudioForLow
    });
    const dispatch = useDispatch();
    
  
    function handleTagFilterCheck(event, argumentvalue){
       // console.log("handleTagFilterCheck event.target.value",event.target.value)
       var alarmaudiostate = alarmcurrentaudiostate;
       var updatedaudiostate;
        if(argumentvalue == 'highest'){
            updatedaudiostate = {
                enableAudioForHighest:  !alarmaudiostate.enableAudioForHighest,
                enableAudioForHigh: alarmaudiostate.enableAudioForHigh,
                enableAudioForMedium: alarmaudiostate.enableAudioForMedium,
                enableAudioForLow: alarmaudiostate.enableAudioForLow
            }
            setCheckedState({
                checkedhighest: !alarmaudiostate.enableAudioForHighest,
                checkedhigh: alarmaudiostate.enableAudioForHigh,
                checkedmedium: alarmaudiostate.enableAudioForMedium,
                checkedlow: alarmaudiostate.enableAudioForLow
            });   
              
        }else if(argumentvalue == 'high'){
            updatedaudiostate = {
                    enableAudioForHighest:  alarmaudiostate.enableAudioForHighest,
                    enableAudioForHigh: !alarmaudiostate.enableAudioForHigh,
                    enableAudioForMedium: alarmaudiostate.enableAudioForMedium,
                    enableAudioForLow: alarmaudiostate.enableAudioForLow
            }
            setCheckedState({
                checkedhighest: alarmaudiostate.enableAudioForHighest,
                checkedhigh: !alarmaudiostate.enableAudioForHigh,
                checkedmedium: alarmaudiostate.enableAudioForMedium,
                checkedlow: alarmaudiostate.enableAudioForLow
            });
            
           
        }else if(argumentvalue == 'medium'){
            updatedaudiostate = {
                    enableAudioForHighest:  alarmaudiostate.enableAudioForHighest,
                    enableAudioForHigh: alarmaudiostate.enableAudioForHigh,
                    enableAudioForMedium: !alarmaudiostate.enableAudioForMedium,
                    enableAudioForLow: alarmaudiostate.enableAudioForLow
            }
            setCheckedState({
                checkedhighest: alarmaudiostate.enableAudioForHighest,
                checkedhigh: alarmaudiostate.enableAudioForHigh,
                checkedmedium: !alarmaudiostate.enableAudioForMedium,
                checkedlow: alarmaudiostate.enableAudioForLow
            });
            
        }else if(argumentvalue == 'low'){
            updatedaudiostate = {
                    enableAudioForHighest:  alarmaudiostate.enableAudioForHighest,
                    enableAudioForHigh: alarmaudiostate.enableAudioForHigh,
                    enableAudioForMedium: alarmaudiostate.enableAudioForMedium,
                    enableAudioForLow: !alarmaudiostate.enableAudioForLow
            }
            setCheckedState({
                checkedhighest: alarmaudiostate.enableAudioForHighest,
                checkedhigh: alarmaudiostate.enableAudioForHigh,
                checkedmedium: alarmaudiostate.enableAudioForMedium,
                checkedlow: !alarmaudiostate.enableAudioForLow
            });
            
        }
        dispatch(updatealarmaudiostate(updatedaudiostate))
        
        
    }


    return(
        <div>
        {/*    <Typography sx={{ fontSize: '36px', fontWeight: 700, color: "#000000" }}>General</Typography>
            <Typography sx={{ fontSize: '14px', fontWeight: 400, color: "#000000" }}>Customize settings based on your personal preferences. This is for your user login only and does not affect other users in your organization.</Typography>
        */}
            <Box>
                <div style={{display:"flex", flexDirection:"row"}}>
                    <div style={{marginLeft:"15px",marginTop:"7px"}}><LK_Settings color={"#005C8E"} width={"17px"} height={"17px"} /></div>
                    <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px",marginTop:"6px", textAlign:"left"}}>Priority Audio Settings</Typography>
                </div>
                <div style={{display:"flex", flexDirection:"row",alignItems:'center',marginTop:"7px"}}>
                    <div>
                        <Checkbox checkedIcon={<CheckBoxOutlinedIcon />} style={{color:"008CD7", paddingBottom:"0px",paddingTop:"0px"}}
                            checked={checkedstate.checkedhighest}
                            sx={{
                                color: 'var(--HighlightedText_Stroke)',
                                '& .MuiSvgIcon-root': {
                                    fontSize: '20px',
                                    color: 'var(--HighlightedText_Stroke)'
                                }
                                }}
                            onChange={(event) => handleTagFilterCheck(event,'highest')}
                        />
                    </div>
                    <div style={{paddingTop:"3px"}}>
                        <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px", textAlign:"left"}}>Enable Audio for Highest Priority</Typography>
                    </div>
                    
                </div>
                <div style={{display:"flex", flexDirection:"row",alignItems:'center',marginTop:"7px"}}>
                    <div>
                        <Checkbox checkedIcon={<CheckBoxOutlinedIcon />} style={{color:"008CD7", paddingBottom:"0px",paddingTop:"0px"}}
                            checked={checkedstate.checkedhigh}
                            sx={{
                                color: 'var(--HighlightedText_Stroke)',
                                '& .MuiSvgIcon-root': {
                                    fontSize: '20px',
                                    color: 'var(--HighlightedText_Stroke)'
                                }
                                }}
                            onChange={(event) => handleTagFilterCheck(event, 'high')}
                        />
                    </div>
                    <div style={{paddingTop:"3px"}}>
                        <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px", textAlign:"left"}}>Enable Audio for High Priority</Typography>
                    </div>
                    
                </div>
                <div style={{display:"flex", flexDirection:"row",alignItems:'center',marginTop:"7px"}}>
                    <div>
                        <Checkbox checkedIcon={<CheckBoxOutlinedIcon />} style={{color:"008CD7", paddingBottom:"0px",paddingTop:"0px"}}
                            checked={checkedstate.checkedmedium}
                            sx={{
                                color: 'var(--HighlightedText_Stroke)',
                                '& .MuiSvgIcon-root': {
                                    fontSize: '20px',
                                    color: 'var(--HighlightedText_Stroke)'
                                }
                                }}
                            onChange={(event) => handleTagFilterCheck(event, 'medium')}
                        />
                    </div>
                    <div style={{paddingTop:"3px"}}>
                        <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px", textAlign:"left"}}>Enable Audio for Medium Priority</Typography>
                    </div>
                    
                </div>
                <div style={{display:"flex", flexDirection:"row",alignItems:'center',marginTop:"7px"}}>
                    <div>
                        <Checkbox checkedIcon={<CheckBoxOutlinedIcon />} style={{color:"008CD7", paddingBottom:"0px",paddingTop:"0px"}}
                            checked={checkedstate.checkedlow}
                            sx={{
                                color: 'var(--HighlightedText_Stroke)',
                                '& .MuiSvgIcon-root': {
                                    fontSize: '20px',
                                    color: 'var(--HighlightedText_Stroke)'
                                }
                                }}
                            onChange={(event) => handleTagFilterCheck(event, 'low')}
                        />
                    </div>
                    <div style={{paddingTop:"3px"}}>
                        <Typography sx={{fontSize:"16px",fontFamily:"Roboto",color:'var(--SecondaryText)',fontWeight: 400, marginLeft:"14px", textAlign:"left"}}>Enable Audio for Low Priority</Typography>
                    </div>
                    
                </div>
            </Box>
           
        </div>
    )
}